import { HttpErrorResponse } from '@angular/common/http';
import { ErrorBusinessCode } from '@eemo/api-client';

export class ReferralHelper {
  /** limit used to load the whole referral list of an agent (the API max) */
  public static readonly LIST_LIMIT = 500;

  public static readonly SUBSCRIPTION_REQUIRED_TITLE = 'Abonnement annuel requis';
  public static readonly SUBSCRIPTION_REQUIRED_CONTENT =
    "Le parrainage est réservé aux agents disposant d'un abonnement annuel actif (Pro ou Max).";

  private static readonly BUSINESS_ERROR_MESSAGES: Partial<Record<ErrorBusinessCode, string>> = {
    [ErrorBusinessCode.REFERRAL_PROGRAM_DISABLED]: "Le programme de parrainage n'est pas encore ouvert.",
    [ErrorBusinessCode.REFERRAL_NOT_ELIGIBLE]:
      'Un abonnement annuel actif (Pro ou Max) est nécessaire pour parrainer un contact.',
    [ErrorBusinessCode.REFERRAL_LIMIT_REACHED]: 'Vous avez atteint le nombre maximum de parrainages en cours.',
    // RG-4 : the message must stay generic, the reason is not disclosed
    [ErrorBusinessCode.REFERRAL_EMAIL_NOT_ALLOWED]: 'Ce contact ne peut pas être parrainé.',
    [ErrorBusinessCode.BONUS_WALLET_PAYMENT_NOT_ALLOWED]:
      'Un abonnement annuel actif (Pro ou Max) est nécessaire pour demander le paiement de votre cagnotte.',
    [ErrorBusinessCode.BONUS_WALLET_EMPTY]: 'La cagnotte est vide.',
    [ErrorBusinessCode.BONUS_WALLET_PAYMENT_ALREADY_REQUESTED]: 'Une demande de paiement est déjà en cours.',
    [ErrorBusinessCode.BONUS_WALLET_NEGATIVE_BALANCE]: 'Le solde de la cagnotte ne peut pas devenir négatif.',
    [ErrorBusinessCode.BONUS_WALLET_NOT_EMPTY]:
      "La cagnotte de parrainage de cet utilisateur n'est pas vide : remboursez-la ou ajustez-la avant de supprimer le compte.",
  };

  /** the user message of a referral / bonus wallet business error, undefined for any other error */
  public static businessErrorMessage(err: HttpErrorResponse): string | undefined {
    const code: ErrorBusinessCode = err?.error?.businessCode;
    return code ? ReferralHelper.BUSINESS_ERROR_MESSAGES[code] : undefined;
  }
}
